export default function NotFoundRoute(){
  return (
    <section>
      <h2>404 - Page not found</h2>
      <p>Try going back to your previous page or login.</p>
    </section>
  ); 
}
